const apiUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

export const phpCode = `
use Illuminate\\Support\\Facades\\Http;

// Set up the API endpoint and your public key
$url = '${apiUrl}/merchant/access-token';
$publicKey = 'your_public_key';

// Make the POST request using Laravel's HTTP client
$response = Http::withHeaders([
    'Content-Type' => 'application/json'
])->post($url, [
    'public_key' => $publicKey,
]);

if ($response->successful()) {
    return response()->json($response->json());
} else {
    return response()->json($response->json());
}
`;

export const javaCode = `
import java.io.OutputStream;
import java.net.HttpURLConnection;
import java.net.URL;
import java.util.Scanner;

public class APIRequest {

    public static void main(String[] args) {
        String apiUrl = '${apiUrl}/merchant/access-token';
        String publicKey = "your_public_key";

        try {
            URL url = new URL(apiUrl);
            HttpURLConnection conn = (HttpURLConnection) url.openConnection();

            conn.setRequestMethod("POST");
            conn.setRequestProperty("Content-Type", "application/json");
            conn.setDoOutput(true);

            String jsonInput = "{ \\"public_key\\": \\"" + publicKey + "\\" }";

            try (OutputStream os = conn.getOutputStream()) {
                byte[] input = jsonInput.getBytes("utf-8");
                os.write(input, 0, input.length);
            }

            int status = conn.getResponseCode();
            if (status == HttpURLConnection.HTTP_OK) {
                try (Scanner scanner = new Scanner(conn.getInputStream(), "utf-8")) {
                    StringBuilder response = new StringBuilder();
                    while (scanner.hasNextLine()) {
                        response.append(scanner.nextLine());
                    }
                    System.out.println("Response: " + response.toString());
                }
            } else {
                try (Scanner scanner = new Scanner(conn.getErrorStream(), "utf-8")) {
                    StringBuilder errorResponse = new StringBuilder();
                    while (scanner.hasNextLine()) {
                        errorResponse.append(scanner.nextLine());
                    }
                    System.err.println("Error: " + errorResponse.toString());
                }
            }

            conn.disconnect();

        } catch (Exception e) {
            System.err.println("Error: " + e.getMessage());
            e.printStackTrace();
        }
    }
}
`;

export const phpCode2 = `
{
    "status": "success",
    "payment_url": "...."
}`;
export const javaCode2 = `
{
    "status": "success",
    "payment_url": "...."
}`;

export const phpCode3 = `// Token invalid or expired (401)
{
    "status": "error",
    "message": "Token is invalid or expired"
}

// For validation rules error (400)
{
    "status": "error",
    "message": [
        "The transaction id has already been taken."
    ]
}`;
export const javaCode3 = `// Token invalid or expired (401)
{
    "status": "error",
    "message": "Token is invalid or expired"
}

// For validation rules error (400)
{
    "status": "error",
    "message": [
        "The transaction id has already been taken."
    ]
}`;

export const phpCode4 = `// API endpoint and sandbox credentials
$url = '${apiUrl}/merchant/make-payment';
$authToken = 'your_authorization_token_here'; // Replace with your actual token

// Request payload
$data = [
    'amount' => 100.00, // Example amount
    'currency' => 'USD', // Example currency
    'transaction_id' => 'ABC123456789', // Unique transaction ID
    'description' => 'Test payment', // Transaction description
    'ipn_url' => 'https://yourdomain.com/ipn', // Notification URL (optional)
    'callback_url' => 'https://yourdomain.com/callback', // Callback URL (optional)
    'customer_name' => 'John Doe', // Customer name (optional)
    'customer_email' => 'johndoe@example.com', // Customer email (optional)
];

// Initialize cURL
$ch = curl_init($url);

// Set up the request headers
$headers = [
    'Content-Type: application/json',
    'Authorization: Bearer ' . $authToken, // Add the authorization token
];

// Configure cURL options
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($data));
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

// Execute the POST request
$response = curl_exec($ch);

// Handle errors
if (curl_errno($ch)) {
    echo 'cURL Error: ' . curl_error($ch);
} else {
    // Parse and display the response
    $httpCode = curl_getinfo($ch, CURLINFO_HTTP_CODE);

    if ($httpCode === 200) {
        $responseData = json_decode($response, true);
        print_r($responseData); // Example output
    } else {
        echo 'Error: HTTP Code ' . $httpCode . PHP_EOL;
        echo 'Message: ' . $response . PHP_EOL;
    }
}

// Close cURL
curl_close($ch);`;

export const javaCode4 = `
// API endpoint and sandbox credentials
const url = "${apiUrl}/merchant/make-payment";
const authToken = "your_authorization_token_here"; // Replace with your actual token

// Request payload
const data = {
  amount: 100.0,           // Example amount
  currency: "USD",         // Example currency
  transaction_id: "ABC123456789", // Unique transaction ID
  description: "Test payment",    // Transaction description
  ipn_url: "https://yourdomain.com/ipn",        // Notification URL (optional)
  callback_url: "https://yourdomain.com/callback", // Callback URL (optional)
  customer_name: "John Doe",       // Customer name (optional)
  customer_email: "johndoe@example.com", // Customer email (optional)
};

// Send POST request
async function makePayment() {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authToken,
      },
      body: JSON.stringify(data),
    });

    // Parse response
    const result = await response.json();

    if (response.ok) {
      console.log("Payment Response:", result);
    } else {
      console.log("Error: HTTP Code", response.status);
      console.log("Message:", result);
    }
  } catch (error) {
    console.error("Request Error:", error.message);
  }
}

makePayment();
`;

export const phpCode5 = `{
    "status": "success",
    "payment_url": "..."
}`;

export const javaCode5 = `{
    "status": "success",
    "payment_url": "..."
}`;

export const phpCode6 = `// Token invalid or expired (401)
{
    "status": "error",
    "message": "Token is invalid or expired"
}

// For validation rules error (400)
{
    "status": "error",
    "message": [
        "The transaction id has already been taken."
    ]
}`;

export const javaCode6 = `// Token invalid or expired (401)
{
    "status": "error",
    "message": "Token is invalid or expired"
}

// For validation rules error (400)
{
    "status": "error",
    "message": [
        "The transaction id has already been taken."
    ]
}`;

export const phpCode7 = `// Assuming the necessary data is available
    $secretKey = ''; // Define your secret key here
    $data = $_GET['data']; // Get the 'data' parameter from the request
    $receivedSignature = $_GET['signature']; // Get the 'signature'

    // Recreate the signature
    $dataToHash = $data['transaction_id'] . $data['total_amount'];
    $generatedSignature = hash_hmac('sha256', $dataToHash, $secretKey);

    // Verify the signature
    if ($generatedSignature === $receivedSignature) {
        // Perform the task
        // Your task execution code here
    }`;

export const javaCode7 = `
// Required for HMAC hashing
import crypto from "crypto";

// Assuming the necessary data is available
const secretKey = ""; // Define your secret key here

// Example: Express request handler
function verifySignature(req, res) {
  const data = req.query.data;          // 'data' param from request
  const receivedSignature = req.query.signature; // 'signature' param

  // If data arrives as JSON string, parse it
  let parsedData = data;
  if (typeof data === "string") {
    try {
      parsedData = JSON.parse(data);
    } catch (err) {
      return res.status(400).send("Invalid data format");
    }
  }

  // Recreate the signature
  const dataToHash = parsedData.transaction_id + parsedData.total_amount;

  const generatedSignature = crypto
    .createHmac("sha256", secretKey)
    .update(dataToHash)
    .digest("hex");

  // Verify the signature
  if (generatedSignature === receivedSignature) {
    // Perform your task here
    console.log("Signature Verified Successfully");
    return res.send("Signature verified!");
  } else {
    return res.status(403).send("Invalid signature");
  }
}

export default verifySignature;
`;
